KROWN.themeName = 'Split';
KROWN.themeVersion = '4.0.4';

const executeOnceOnDomContentLoaded = ()=>{

  // tab navigation

  let activeElement = document.activeElement;
  document.addEventListener('keyup', e=>{
    if ( e.keyCode == window.KEYCODES.TAB ) {
      if ( activeElement.classList.contains('focus') && e.target != activeElement ) {
        activeElement.classList.remove('focus');
      }
      if ( e.target.classList.contains('product-variant__input') ||
      	e.target.classList.contains('button') ||
      	e.target.classList.contains('product-item') ||
      	e.target.classList.contains('spr-summary-actions-newreview') ||
      	e.target.classList.contains('site-box-content-to-focus')
      ) {
        e.target.classList.add('focus');
      } 
      activeElement = document.activeElement;
    }
  });

  // newsletter has jump

  if ( window.location.pathname.includes('/challenge') ) {
    setTimeout(()=>{
      window.scroll({
        top: 0, 
        behavior: 'auto'
      });
    }, 300);
  }

  // fix image link borders

  document.querySelectorAll('.rte a img').forEach(elm=>{
    elm.parentNode.style.border = 'none';
  });

  // Filter handle
  
  if ( document.getElementById('site-filter-handle') ) {
    document.getElementById('site-filter-handle').addEventListener('click', e=>{
      e.preventDefault();
      document.getElementById('site-filters').show();
      document.getElementById('site-filter-handle').setAttribute('aria-expanded', 'true');
    });
  }

  // fix quick add to cart

  setTimeout(()=>{
    if ( document.querySelector('modal-box quick-view-product') ) {
      document.querySelector('modal-box quick-view-product').init();
    }
    if ( document.querySelector('modal-box quick-add-to-cart') ) {
      document.querySelector('modal-box quick-add-to-cart').init();
      document.querySelector('modal-box product-form').init();
    }
  }, 3050);

  // show newsletter popup confimation

  if ( document.location.search == '?customer_posted=true' && document.location.hash == '#newsletter-popup' && document.getElementById('modal-popup') ) {
    const newsletterPopup = document.getElementById('modal-popup');
    newsletterPopup.show();
    localStorage.setItem(newsletterPopup._modalKey, JSON.stringify({
      'shown': (new Date().getTime()),
      'content': newsletterPopup._modalText
    }));	
    setTimeout(()=>{
      newsletterPopup.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{newsletterPopup.hide(true)}));
    }, 100);
    clearTimeout(newsletterPopup._modalTimeout);
  }

  // custom cart listener
  
  if ( document.querySelector('cart-form') ) {
    document.querySelector('cart-form').addEventListener('cart-updated', ()=>{
      if ( document.body.classList.contains('template-cart') ) {

        if ( document.querySelector('#AjaxCartForm .subtitle') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = document.querySelector('#AjaxCartForm .subtitle').innerHTML;
        }
        if ( document.getElementById('AjaxCartSubtotal').querySelector('[data-cart-empty]') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = "";
          if ( ! document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
            document.getElementById('AjaxCartSubtotal').append(document.getElementById('section-cart').querySelector('template').content.cloneNode(true))
          } else {
            document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'block';
          }
        } else if ( document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
          document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'none';
        }

      }

      if ( document.querySelector('cart-recommendations') && parseInt(document.querySelector('[data-cart-count]').textContent ) == 0 ) {
        document.querySelector('cart-recommendations').innerHTML = '';
      }

    });
  }

  // recommended products listener

  if ( document.querySelector('#main-product-recommendations') ) {
    document.querySelector('#main-product-recommendations').addEventListener('product-recommendations-loaded', ()=>{
      eval(document.querySelector('#main-product-recommendations .js-fix-height').textContent);
    });
  }

}

if ( document.readyState !== 'loading' ) {
  executeOnceOnDomContentLoaded();
} else {
  document.addEventListener('DOMContentLoaded', executeOnceOnDomContentLoaded);
}

//OPEN SWIPER
const getSwiperClose = document.querySelector('.swiper-dsc__close');
const getCtnSwiper = document.querySelector('.swiper-dsc p');
const getSwiperOpen = document.querySelector('.swiper-dsc a');

getCtnSwiper && (getCtnSwiper.style.height = `${
  getCtnSwiper.scrollHeight
}px`);
getSwiperClose && getSwiperClose.addEventListener('click', () => {
  getCtnSwiper.style.height = 0;
  getSwiperClose.classList.add('hidden-btn');
  getSwiperOpen.classList.add('active');
});
getSwiperOpen && getSwiperOpen.addEventListener('click', () => {
  getCtnSwiper.style.height = `${
    getCtnSwiper.scrollHeight
  }px`;
  getSwiperClose.classList.remove('hidden-btn');
  getSwiperOpen.classList.remove('active');
});
//OPEN CATEGORIES
const getAllBtnCats = document.querySelectorAll('.collect-header__item');
const getAllCtnCats = document.querySelectorAll('.collect-categories');
getAllBtnCats[0] && getAllBtnCats[0].firstElementChild.classList.add('active');
getAllBtnCats.forEach((data) => {
  data.addEventListener('click', () => {
    getAllBtnCats.forEach((data) => {
      data.firstElementChild.classList.remove('active');
    });
    data.firstElementChild.classList.add('active');
    const getDataAtr = data.dataset.categoriebtn;
    getAllCtnCats.forEach((data) => {
      if (data.dataset.categoriectn == getDataAtr) {
        data.classList.add('active');
        data.style.height = `${
          data.scrollHeight
        }px`;
        data.style.padding = "0 0 40px 0";
      } else {
        data.classList.remove('active');
        data.style.height = `0`;
        data.style.padding = "0";
      }
    });
  });
});

//LOADER GENERAL
const getHeaderGeneral = document.querySelector('.loader-general');

//EFECT ZOOM PRODUCTOS
function Zoom(e){
  var zoomer = e.currentTarget;
  e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
  e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
  x = offsetX/zoomer.offsetWidth*100
  y = offsetY/zoomer.offsetHeight*100
  zoomer.style.backgroundPosition = x + '% ' + y + '%';
}

const ZoomProducts = ()=>{
  const getImages = document.querySelectorAll('.product-gallery-item');
  [...getImages].map((data)=>{
    const getSrc = data.querySelector('img').src;
    data.style.background = `url('${getSrc}'), no-repeat`;
    data.addEventListener('mousemove', (e)=>{
      Zoom(e);
      console.log('hola');
    });
    console.log(getSrc);
  });
}



//FUNCIONES QUE SE EJECUTAN CUANDO CARGA LA PÁGINA
window.addEventListener('load', ()=>{
  setTimeout(()=>{
    getHeaderGeneral.classList.add('active');
  },1000);
  // try {ZoomProducts()}catch(err){console.log(err)}
});